// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emoji-picker-react img.emoji-img {\n  height: 25px;\n  width: 25px;\n  margin: 5px;\n}\n\n.emoji-picker-react .native {\n  height: 25px;\n  width: 25px;\n  margin: 5px;\n  font-size: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
